import React, { ChangeEvent, Component } from 'react';
import CustomTable from '../../../../custom/CustomTable';
import { RootState } from '../../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { ColumnProps } from 'primereact/column';
import { customConfirm } from '../../../../custom/CustomPopupConfirm';
import { ApiVariableParameter } from '../../../../../domain/remote/httpVariable/HttpVariableDomains';
import CustomInput from '../../../../custom/CustomInput';
import MessageUtil from '../../../../../util/MessageUtil';
import RoleHelper from '../../../../../RoleHelper';
import { ActionState } from '../../../../../redux/reducers/ActionReducer';
import { changeAction, changeActionIsUpdate, clearAction } from '../../../../../redux/actions/ActionActions';
import { enterComponent, leaveComponent } from '../../../../../redux/actions/ComponentActions';
import { FormicaProps, withFormica } from '../../../../../helpers/withFormica';
import { ApiActionJsonModel } from '../../../../../domain/collection/rule/action/ActionDomains';
import Icon from '../../../../../icons/Icon';
import ComponentName from '../../../../../constant/ComponentName';
import LanguageUtil from '../../../../../util/LanguageUtil';

class ApiHeadersListComponent extends Component<Props> {
  public render() {
    return (
      <div className={'overflow-y-hidden lg:!max-h-[calc(100vh-28.625rem)] rounded-lg'}>
        <CustomTable columns={this.getColumns()} value={this.prepareHeaders()} />
      </div>
    );
  }

  private prepareHeaders = () => {
    const {
      action: { action },
    } = this.props;
    const keys = Object.keys((action as ApiActionJsonModel).headers || {}) as string[];
    const values = Object.values((action as ApiActionJsonModel).headers || {}) as string[];
    const headers = [];
    for (let i = 0; i < keys.length; i++) {
      headers.push({ key: keys[i], value: values[i] });
    }
    return headers;
  };

  private deleteApiHeader = (header: { key: string; value: string | number[] }) => {
    const {
      action: { action },
      changeAction,
    } = this.props;
    delete (action as ApiActionJsonModel).headers[header.key];
    changeAction(action);
  };

  private getColumns = (): ColumnProps[] => {
    return [
      {
        field: 'key',
        header: LanguageUtil.get({ id: 'pages.action.api.headers.table.key', defaultMessage: 'Key' }),
        className: 'min-w-[30%]',
        body: (headerParameter: any) => (
          <CustomInput
            inputType={'ghost'}
            type={'text'}
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeKey(e, headerParameter)}
            value={headerParameter.key}
            data-testid={`${ComponentName.ACTION}_header_key_input_${headerParameter.key}`}
          />
        ),
      },
      {
        field: 'value',
        header: LanguageUtil.get({ id: 'pages.action.api.headers.table.value', defaultMessage: 'Value' }),
        className: 'min-w-[30%]',
        body: (headerParameter: any) => (
          <CustomInput
            inputType={'ghost'}
            type={'text'}
            disabled={!RoleHelper.canEdit('Action')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeValue(e, headerParameter)}
            value={headerParameter.value}
            data-testid={`${ComponentName.ACTION}_header_value_input_${headerParameter.key}`}
          />
        ),
      },
      {
        field: 'description',
        header: LanguageUtil.get({ id: 'pages.action.api.headers.table.description', defaultMessage: 'Description' }),
        className: 'min-w-[30%]',
      },
      {
        field: 'action',
        header: LanguageUtil.get({ id: 'pages.action.api.headers.table.action', defaultMessage: 'Action' }),
        className:'max-w-[100px]',
        alignHeader: 'center',
        sortable: false,
        body: (variableParameter: ApiVariableParameter) => (
          <div
            className={'flex items-center justify-center'}
            onClick={(e: any) => {
              e.stopPropagation();
              e.preventDefault();
              RoleHelper.canEdit('Action') &&
                customConfirm({
                  target: e.currentTarget,
                  accept: () => this.deleteApiHeader(variableParameter),
                  message: LanguageUtil.get({ id: 'messages.confirm.removeVariable', defaultMessage: 'Are you sure remove this variable ?' }),
                });
            }}
            data-testid={`${ComponentName.ACTION}_api_headers_list_${variableParameter.key}_remove_button`}
          >
            <Icon
              icon={'delete'}
              size={20}
              color={'primary'}
              className={'hover:text-primary text-primary hover:cursor-pointer flex items-center justify-center'}
            />
          </div>
        ),
      },
    ];
  };

  private onChangeKey = (e: ChangeEvent<HTMLInputElement>, headerParameter: any) => {
    const {
      action: { action },
      changeAction,
    } = this.props;
  };

  private onChangeValue = (e: ChangeEvent<HTMLInputElement>, headerParameter: any) => {
    const {
      action: { action },
      changeAction,
    } = this.props;
    !headerParameter.key.includes('Authorization')
      ? ((action as ApiActionJsonModel).headers[headerParameter.key] = e.target.value)
      : MessageUtil.warning({
          summary: LanguageUtil.get({ id: 'common.label.authorization', defaultMessage: 'Authorization' }),
          detail: (
            <div>
              {LanguageUtil.get({
                id: 'messages.onlyChangeAuthorization',
                defaultMessage: "You can only change 'Authorization' header in 'Authorization' tab",
              })}
            </div>
          ),
        });
    changeAction(action);
  };
}

interface Props extends ReduxProps, FormicaProps {}

const mapStateToProps = (state: RootState) => ({
  action: state.action as ActionState,
  isUpdate: state.action.isUpdate,
  lastCategory: state.page.lastCategory,
});
const mapDispatchToProps = {
  changeActionIsUpdate,

  changeAction,
  clearAction,
  enterComponent,
  leaveComponent,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(ApiHeadersListComponent));
